import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import _ from 'lodash'

import { addToFavourites, removeFromFavourites } from './actions'

export default (idSelector = () => null) => {
    function mapStateToProps(state, hocProps) {
        const id = idSelector(hocProps)

        return {
            shouldAddToFavourites: !state
                .getIn(['ui', 'entityStack', 'favourites', 'entities'])
                .find((favourite) => _.toString(favourite.get('entId')) === _.toString(id)),
        }
    }

    function mapDispatchToProps(dispatch) {
        return bindActionCreators({ addToFavourites, removeFromFavourites }, dispatch)
    }

    return (WrappedComponent) => {
        @connect(mapStateToProps, mapDispatchToProps)
        class HocFavourites extends Component {
            static propTypes = {
                addToFavourites: PropTypes.func.isRequired,
                removeFromFavourites: PropTypes.func.isRequired,
                shouldAddToFavourites: PropTypes.bool.isRequired,
            }

            render() {
                return <WrappedComponent {...this.props} />
            }
        }

        return HocFavourites
    }
}
